import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/joy';
import EventRow from './EventRow';

export default function EventsCompactFeed({ hubId, events, loading }) {
    const navigate = useNavigate();
    const items = (events || []).slice(0, 10);

    return (
        <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent sx={{ py: 1 }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                    <Typography level="title-sm" fontWeight="bold">
                        Events
                    </Typography>
                    <Button
                        size="sm"
                        variant="plain"
                        onClick={() => navigate(`/hub/${hubId}/events`)}
                    >
                        View all
                    </Button>
                </Stack>

                {loading && (
                    <Typography level="body-sm" textColor="neutral.500">
                        Loading events…
                    </Typography>
                )}

                {!loading && items.length === 0 && (
                    <Typography level="body-sm" textColor="neutral.500">
                        No events uploaded for this range
                    </Typography>
                )}

                {!loading && items.length > 0 && (
                    <Box>
                        {items.map((event) => (
                            <EventRow key={event.id} event={event} dense />
                        ))}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
}
